let faqs = {
  servicio: {
    name: "Sobre Nörlux y nuestro servicio",
    array:[
      {
        id: 1,
        pregunta: "¿Qué tipo de aberturas fabrican en Nörlux",
        respuesta: "En Nörlux fabricamos ventanas de PVC de la marca Muchtek, productos de alta prestación que cumplen con el estándar de calidad argentina."
      },
      {
        id: 2,
        pregunta: "¿Trabajan solo con PVC?",
        respuesta: "Si, en Norlux, trabajamos únicamente PVC ya que es la mejor opción para tus ventanas."
      },
      {
        id: 3,
        pregunta: "¿Tienen showroom para ver los productos?",
        respuesta: "Si, contamos con un showroom para que puedas ver las aberturas de tu futuro hogar en nuestra planta en gral pacheco."
      },
      {
        id: 4,
        pregunta: "¿Dónde están ubicados?",
        respuesta: "En general pacheco, Tigre."
      },
      {
        id: 5,
        pregunta: "¿En qué zonas trabajan o hacen envíos?",
        respuesta: "Trabajamos sobre todo en CABA y Gran Buenos Aires pero podemos evaluar otras zonas, pero el cliente debe contemplar un costo adicional por viáticos y alojamiento en caso fuera necesario. "
      },
      {
        id: 6,
        pregunta: "¿Cuál es el proceso completo desde que los contacto hasta que instalan las aberturas?",
        respuesta: "Se realiza una visita técnica para comprender la necesidad de cada cliente, se realiza un presupuesto a medida de acuerdo a los planos suministrados, luego de cerrar la operación, se comienza con la medición y fabricación de la obra, luego se entrega y se realiza una visita post venta para corroborar que todo funcione de acuerdo a lo esperado. Luego, nos aseguramos de que cada cliente haya quedado conforme con todo el servicio realizado. "
      },
      {
        id: 7,
        pregunta: "¿Puedo pedir solo la fabricación sin instalación?",
        respuesta: "Si, se pueden pedir solo las ventanas y la instalación realizarla uno mismo, además, podemos recomendar instaladores para que realicen el trabajo."
      },
      {
        id: 8,
        pregunta: "¿Hacen instalaciones en obras en construcción?",
        respuesta: "Si, otorgamos un servicio de instalación con garantía de trabajo. "
      },
      {
        id: 9,
        pregunta: "¿Trabajan con arquitectos y desarrolladores?",
        respuesta: "Si, nos adecuamos a cada cliente, trabajamos con consumidores finales, arquitectos y desarrolladores."
      },
      {
        id: 10,
        pregunta: "¿Qué pasa si tengo planos pero aún no hice la obra?",
        respuesta: "Se puede cotizar el proyecto para obtener un estimado del costo total de aberturas."
      },
      {
        id: 11,
        pregunta: "¿Ofrecen asesoramiento previo al inicio de la obra?",
        respuesta: "Si, en Nörlux ofrecemos una visita sin costo alguno dentro de CABA y GBA para poder asesorar e interpretar las necesidades puntuales de cada cliente. "
      },
      {
        id: 12,
        pregunta: "¿Cuánto tiempo tardan en enviar un presupuesto?",
        respuesta: "El plazo de demora para la entrega de presupuestos es de 24 hs."
      },
      {
        id: 13,
        pregunta: "¿Qué información necesito para pedir un presupuesto?",
        respuesta: "Es de gran importancia enviar en lo posible una planilla de carpinterias donde se aclaren, medidas, tipologías, tipos de acristalamiento, color, mosquiteros, etc. Y en lo posible entregar los planos de planta para poder evaluar el movimiento e izaje de las aberturas. "
      },
      {
        id: 14,
        pregunta: "¿Puedo pedir una cotización sin visita a obra?",
        respuesta: "Si, con la planilla de carpinterias se puede solicitar un presupuesto. Es importante dejar los datos de contacto para que ante cualquier duda podamos resolverla mediante este medio."
      },
      {
        id: 15,
        pregunta: "¿Tienen garantía los productos?",
        respuesta: "Los productos de Nörlux cuentan con una garantía de 12 meses por cualquier problema que pudiera surgir de mala fabricación o roturas de vidrio, ajenas a golpes. Para ello, se realizara una inspección, junto al cliente y en caso de detectar que el problema haya sido por parte de la empresa, se arreglara o cambiara la ventana en caso de ser necesario. Contrario a esto, en caso de detectar que el problema es ajeno a la fabricación de la abertura, se le cobrara al cliente un recargo por la visita. "
      },
      {
        id: 16,
        pregunta: "¿Ofrecen postventa si tengo un problema?",
        respuesta: "Si, Nörlux tiene un servicio post- venta para cualquier inconveniente u mantenimiento que pudiera surgir."
      },
      {
        id: 17,
        pregunta: "¿Qué medios de pago aceptan?",
        respuesta: "Se aceptan pagos en efectivo, dólares o pesos y transferencias bancarias. "
      },
      {
        id: 18,
        pregunta: "¿Ofrecen planes de financiación?",
        respuesta: "No se ofrecen planes de financiación actualmente."
      },
      {
        id: 19,
        pregunta: "¿Trabajan con proyectos personalizados?",
        respuesta: "Si, en Nörlux brindamos soluciones e intentamos amoldarnos a los requerimientos de cada proyecto, siempre y cuando estos sean admisibles y no resulten en productos defectuosos."
      }
    ]
  },
  aberturas:{
    name: "Sobre las aberturas de PVC",
    array:[
      {
        id: 1,
        pregunta: "¿Qué ventajas tiene el PVC sobre el aluminio?",
        respuesta: "El PVC es un material noble con grandes propiedades acústicas y térmicas, más allá de contar con perfil multi-camara, el PVC es un material aislante. En el caso del aluminio, es un material conductor, con lo cual, la perdida de energía se transmite directamente por los marcos y hojas. Además, los herrajes utilizados en PVC buscan un acompañamiento térmico y es por eso, se utilizan herrajes multipunto que generan un cierre hermético en todo el perímetro."
      },
      {
        id: 2,
        pregunta: "¿El PVC se deforma con el calor o el sol?",
        respuesta: "No, el PVC utilizado en las ventanas, no es el mismo utilizado en mesas/sillas plásticas de exterior. Nuestros perfiles de PVC cuentan con un alto componente de dióxido de titanio, lo cual mejora sustancialmente la resistencia UV e infrarroja de la luz solar. Permitiendo a las ventanas exponerse a una alta exposición de rayos sin generar deterioros o decoloramientos es sus perfiles, ya sean blancos o foliados."
      },
      {
        id: 3,
        pregunta: "¿Requiere mantenimiento?",
        respuesta: "El PVC es libre de mantenimiento o pintura. No asi los herrajes para las ventanas, ya sean de aluminio o PVC, los herrajes requieren de cierto mantenimiento (lubricación) ya que el mismo se reseca con el tiempo. En Nörlux, ofrecemos un servicio post-venta que realiza el mantenimiento de las mismas."
      },
      {
        id: 4,
        pregunta: "¿Qué tipo de cerramientos pueden hacer con PVC?",
        respuesta: "Se pueden realizar cerramientos de doble contacto,  ya sean ventanas de abrir, banderolas, oscilobatientes, proyectantes, puertas, plegadizas, fijos móviles o ventanas corredizas, ya sean pequeñas, medianas o de grandes dimensiones. "
      },
      {
        id: 5,
        pregunta: "¿Se pueden hacer puertas con PVC?",
        respuesta: "Si, se pueden realizar puertas de PVC, las cuales pueden ser, vidriadas, ciegas, con distintos tipos de terminación interior. "
      },
      {
        id: 6,
        pregunta: "¿El PVC es un material reciclable?",
        respuesta: "El PVC utilizado en las ventanas es PVC virgen pero el PVC en sí, es un material altamente reciclable. En Nörlux contamos con proveedores que realizan el reciclaje del “scrap” resultante de la fabricación de PVC, contribuyendo activamente al cuidado del medioambiente y al impacto en la huella de carbono."
      },
      {
        id: 7,
        pregunta: "¿Qué tipo de vidrio se usa en las ventanas?",
        respuesta: "En las ventanas de PVC se recomienda siempre utilizar doble vidriado hermético (DVH) ya que este acompaña a los beneficios de aislación térmica y acústica otorgados por los perfiles de PVC. También, según la tipología de la ventana, se pueden llegar a hacer triple vidrios herméticos (TVH) si los mismos fueran requeridos."
      },
      {
        id: 8,
        pregunta: "¿Qué nivel de aislamiento acústico tiene?",
        respuesta: "El grado de aislación acústica depende del tipo de perfil a utilizar y el tipo de acristalamiento solicitado, el cual se puede calcular según requerimientos del proyecto y se pueden solicitar las etiquetas de eficiencia energética del producto. "
      },
      {
        id: 9,
        pregunta: "¿Cómo se comporta el PVC en zonas con humedad o salinidad?",
        respuesta: "El PVC no se deteriora en zonas de alta salinidad y es por eso es uno de los materiales más elegidos a la hora de realizar proyectos cercanos al mar."
      },
      {
        id: 10,
        pregunta: "¿Qué colores o acabados están disponibles?",
        respuesta: "Actualmente contamos con una selección de más de 8 tipos de acabados, tanto simil madera con microtexturados negros o gris."
      },
      {
        id: 11,
        pregunta: "¿Hay opciones que imiten madera?",
        respuesta: "Sí, hay una amplia variedad de acabados madera en PVC, los cuales imitan la madera a la perfección, tanto en textura como en las vetas uniformes de la madera."
      },
      {
        id: 12,
        pregunta: "¿Las ventanas de PVC se pueden pintar?",
        respuesta: "No se recomienda pintar las ventanas de PVC de manera casera pero si se pueden pintar del mismo modo que se pintan los vehículos. Este tipo de tratamientos no son habituales y exceden cualquier tipo de garantía que pudiera surgir de problemas con la pintura."
      },
      {
        id: 13,
        pregunta: "¿Qué herrajes usan las aberturas?",
        respuesta: "Nuestras aberturas de PVC utilizan herrajes de primera línea europeos, de la marca RotoFrank o Reze según fuera solicitado por el cliente."
      },
      {
        id: 14,
        pregunta: "¿Las ventanas tienen cierre multipunto?",
        respuesta: "Todas las ventanas de PVC trabajan con cierres multi-punto, dependiendo la cantidad de puntos, de la medida de la ventana."
      }
    ]
  },
  obra:{
    name: "Sobre instalación y obra",
    array:[
      {
        id: 1,
        pregunta: "¿Quién se encarga de la instalación?",
        respuesta: "Nörlux ofrece un servicio de instalación con garantía por 12 meses por problemas que pudieran surgir de una instalación fallida, ya sea por desagotes o mala colocación de las ventanas (niveles, plomos, etc)."
      },
      {
        id: 2,
        pregunta: "¿Cuánto dura una instalación promedio?",
        respuesta: "Depende de la cantidad de aberturas, en Nörlux divivimos la instalación en partes, colocación de marcos, colocación de hojas y colocación de terminaciones, durando un promedio de 7 días, de acuerdo a las unidades a colocar y la complejidad de izaje de las mismas."
      },
      {
        id: 3,
        pregunta: "¿Qué necesito preparar antes de la instalación?",
        respuesta: "Todos los vanos deben estar perfectamente recuadrados, con sus fajas correspondientes en ventanas balcón corredizas. Los vanos deben tener pendiente exterior y se debe contar con un espacio destinado a la descarga y acopio de las ventanas en obras. Además, no se debe impedir el correcto movimiento del personal a la hora de realizar la descarga. Además, debe estar colocado o en su defecto, señalado, cualquier tipo de revestimiento interior (baños, cocinas) que marque un filo interior de la ventana."
      },
      {
        id: 4,
        pregunta: "¿Cómo coordinan la entrega con el avance de obra?",
        respuesta: "Nuestro equipo se comunicara continuamente con el propietario/encargado en obra para coordinar una fecha de entrega óptima para la colación de aberturas que no genere un deterioro de las mismas."
      },
      {
        id: 5,
        pregunta: "¿Puedo instalar ventanas de PVC en una reforma?",
        respuesta: "Si, contamos con perfiles de recubrimiento tipo “cover” para poder colocar las ventanas sobre marcos antiguos (hierro) en seco, pero la misma, se deberá analizar ya que estos marcos existentes, no deberán estar deteriorados/oxidados ya que eso puede perjudicar la nueva ventana."
      },
      {
        id: 6,
        pregunta: "¿Las aberturas de PVC sirven para obras de alto nivel?",
        respuesta: "Si, las ventanas de PVC están pensadas para proyectos de altos requerimientos de confort, siendo estas las más elegidas en proyectos de alta prestación gracias a sus beneficios de confort."
      },
      {
        id: 7,
        pregunta: "¿El PVC resiste impactos o es frágil?",
        respuesta: "El PVC es altamente resistente a impactos. Esto se debe a una alta concentración de dióxido de titanio en la mezcla del componente."
      },
      {
        id: 8,
        pregunta: "¿Puedo colocar mosquiteros o persianas?",
        respuesta: "Si, se pueden colocar tanto persianas como mosquiteros. Lo importante a tener en cuenta a la hora de colocar persianas, es que las mismas sean de alto grado de aislación térmica ya que los cajones de persiana pueden presentar filtraciones de aire, lo cual perjudicaría directamente en el beneficio térmico del PVC."
      },
      {
        id: 9,
        pregunta: "¿Las ventanas de PVC se traban o abren mal con el tiempo?",
        respuesta: "Siempre y cuando se cumplan las condiciones de mantenimiento de los herrajes, los mismos están pensados para una durabilidad de más de 30 años y no deberían sufrir deterioros."
      }
    ]
  },
  generales:{
    name: "Consultas generales",
    array: [
      {
        id: 1,
        pregunta: "¿Cuánto cuesta una ventana de PVC?",
        respuesta: "Depende del color, la tipología y el tipo de acristalamiento, pudiendo haber grandes diferencias de precio, que van desde los USD300 hasta los USD4000 dependiendo el caso. Es por eso, en Nörlux  hacemos los presupuestos a medida de tu proyecto."
      },
      {
        id: 2,
        pregunta: "¿Qué determina el precio de una abertura?",
        respuesta: "El color, la tipología y el tipo de acristalamiento que esta utilizara."
      },
      {
        id: 3,
        pregunta: "¿Puedo encargar solo una ventana o hay mínimo?",
        respuesta: "Se pueden encargar ventanas por unidad pero esto encarece sustancialmente el valor, ya que tiene un alto grado de desperdicio. Cuanta más cantidad de ventanas son, mejor se reparte el costo."
      },
      {
        id: 4,
        pregunta: "¿Cuánto duran las ventanas de PVC?",
        respuesta: "Las ventanas de PVC pueden durar hasta 50 años siempre y cuando se mantengan las condiciones de mantenimiento de los herrajes y el buen uso de las ventanas."
      },
      {
        id: 5,
        pregunta: "¿Qué pasa si tengo un problema después de la instalación?",
        respuesta: "Si llegara a haber un problema por instalación, se deberá comunicar al comercial asignado para que este coordine una visita a obra y busque una solución para el problema."
      }
    ]
  }
}
export default faqs;